import { FaPlus, FaMinus  } from "react-icons/fa";


export default function Prodotti() {
    const categories = [
        {
            title: "Porte",
            items: [
                { name: "Porte in legno", image: "./images/porte-legno.webp" },
                { name: "Porte in vetro", image: "./images/porte-vetro.webp" },
                { name: "Porte blindate", image: "./images/porte-blindate.webp" },
            ],
        },
        {
            title: "Sistemi di Sicurezza",
            items: [
                { name: "Inferriate di sicurezza", image: "./images/inferiate.jpg" },
            ],
        },
        {
            title: "Sistemi Oscuranti",
            items: [
                { name: "Tapparelle avvolgibili", image: "./images/tapparelle.jpeg" },
                { name: "Tende frangisole", image: "./images/frangisole.jpg" },
                { name: "Persiane", image: "./images/persiane.webp" },
            ],
        },
    ];

    return (
        <div className="flex-col p-4 pt-0 xl:pl-20 xl:pr-20 items-center justify-center ">
            <h1 className="text-4xl font-bold text-center p-4">I nostri Prodotti</h1>
            <div className="relative w-full bg-cover bg-center rounded-3xl sm:h-144 h-96" style={{ backgroundImage: `url('./images/serramenti1.jpg')` }}>
                <div className="absolute inset-0 bg-black bg-opacity-30 rounded-xl"></div>
                <div className="absolute left-0 top-0 p-8 font-medium">
                    <p className="text-3xl text-white">Il serramento perfetto per te.</p>
                </div>
            </div>

            <h1 className="sm:text-3xl text-2xl font-bold text-center p-4 mt-4">I materiali dei serramenti</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-16 sm:px-24">
                {/* Primo elemento */}
                <div className="flex flex-col items-center">
                    <div className="w-full bg-contain bg-no-repeat bg-center rounded-3xl border-4 border-logo-color" style={{ backgroundImage: `url('./images/pvc.jpg')`, height: 'auto', aspectRatio: '1/1' }}></div>
                    <div className="p-4">
                        <h1 className="text-xl font-semibold">PVC</h1>
                        <p>
                            I serramenti in PVC (polivinilcloruro) sono realizzati con un materiale plastico resistente, leggero e versatile. Sono molto diffusi per la loro economicità e bassa manutenzione.
                        </p>
                        <br />
                        <p className="flex items-center"><FaPlus className="text-green-500" /> &nbsp;Isolamento termico e acustico eccellente</p>
                        <p className="flex items-center"><FaPlus className="text-green-500"/> &nbsp;Costo contenuto</p>
                        <p className="flex items-center"><FaPlus className="text-green-500"/> &nbsp;Bassa manutenzione</p>
                        
                        <p className="flex items-center"><FaMinus className="text-red-500"/> &nbsp;Non adatto a grandi aperture</p>
                        <p className="flex items-center"><FaMinus className="text-red-500"/> &nbsp;Estetica limitata</p>

                        
                    </div>
                </div>

                {/* Secondo elemento */}
                <div className="flex flex-col items-center">
                    <div className="w-full bg-contain bg-no-repeat bg-center rounded-3xl border-4 border-logo-color" style={{ backgroundImage: `url('./images/legno-alluminio.jpg')`, height: 'auto', aspectRatio: '1/1' }}></div>
                    <div className="p-4">
                        <h1 className="text-xl font-semibold">Legno-Alluminio</h1>
                        <p>
                            I serramenti in legno-alluminio combinano la bellezza naturale del legno all’interno con la resistenza dell’alluminio all’esterno, creando un prodotto durevole e dall’estetica raffinata.
                        </p>
                        <br />
                        <p className="flex items-center"><FaPlus className="text-green-500" /> &nbsp;Eleganza</p>
                        <p className="flex items-center"><FaPlus className="text-green-500"/> &nbsp;Resistenza esterna</p>
                        <p className="flex items-center"><FaPlus className="text-green-500"/> &nbsp;Ottimo isolamento</p>
                        
                        <p className="flex items-center"><FaMinus className="text-red-500"/> &nbsp;Costo elevato</p>
                    </div>
                </div>

                {/* Terzo elemento */}
                <div className="flex flex-col items-center">
                    <div className="w-full bg-contain bg-no-repeat bg-center rounded-3xl border-4 border-logo-color" style={{ backgroundImage: `url('./images/alluminio-legno.jpg')`, height: 'auto', aspectRatio: '1/1' }}></div>
                    <div className="p-4">
                        <h1 className="text-xl font-semibold">Alluminio-Legno</h1>
                        <p>
                            I serramenti in alluminio-legno sono simili a quelli in legno-alluminio, ma invertendo i materiali: l’alluminio è all’interno e il legno all’esterno. Questa configurazione si usa per esigenze estetiche esterne in contesti specifici.
                        </p>
                        <br />
                        <p className="flex items-center"><FaPlus className="text-green-500" /> &nbsp;Durabilità</p>
                        <p className="flex items-center"><FaPlus className="text-green-500"/> &nbsp;Estetica esterna</p>
                        <p className="flex items-center"><FaPlus className="text-green-500"/> &nbsp;Isolamento discreto</p>
                        
                        <p className="flex items-center"><FaMinus className="text-red-500"/> &nbsp;Costo elevato</p>
                        <p className="flex items-center"><FaMinus className="text-red-500"/> &nbsp;Minor resa termica</p>
                    </div>
                </div>
            </div>
            <h1 className="sm:text-3xl text-2xl font-bold text-center p-4 mt-4">Altri servizi</h1>

             <div className="sm:px-24">
            {categories.map((category, index) => (
                <div key={index} className="mb-12">
                    <h2 className="text-xl font-semibold mb-6">{category.title}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-16">
                        {category.items.map((item, idx) => (
                            <div key={idx} className="relative group">
                                <div
                                    className="w-full bg-cover bg-center aspect-square rounded-xl"
                                    style={{ backgroundImage: `url(${item.image})` }}
                                ></div>
                                <div className="absolute inset-0 bg-black bg-opacity-30 rounded-xl flex items-center justify-center opacity-100 ">
                                    <p className="text-white text-lg font-bold">{item.name}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
        </div>
    );
}
